<template>
  <div class="position-relative">
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
      </div>
      <div v-if="loading" class="d-flex justify-content-center m-2">
        <b-spinner variant="primary" />
      </div>
      <b-table
        hover
        class="position-relative"
        :items="items"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="Não foram encontradas solicitações de saques para esta busca"
        v-else
      >
        <!-- Column: Data da solicitação -->
        <template #cell(due_date)="data">
          <div class="text-wrap">
            <span class="align-text-top text-capitalize">{{
              data.item.due_date | onlyDate
            }}</span>
          </div>
        </template>
        <!-- Column: Valor solicitado -->
        <template #cell(total_expected_amount)="data">
          <div class="position-relative w-auto h-auto">
            <div class="font-weight-bolder my-1">
              <div class="text-wrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.total_expected_amount | toCurrency
                }}</span>
              </div>
            </div>
          </div>
        </template>
        <template #cell(total_paid_amount)="data">
          <div class="position-relative w-auto h-auto">
            <div class="font-weight-bolder my-1" >
              <div class="text-wrap">
                <span class="align-text-top text-capitalize">{{
                  data.item.total_paid_amount | toCurrency
                }}</span>
              </div>
            </div>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Exibindo {{ pageItemsFrom }} à {{ pageItemsTo }} de
              {{ totalItems }} itens</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalItems"
              :per-page="itemsPerPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @change="search"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BPagination,
  BSpinner,
  BTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";
import useAppConfig from "@core/app-config/useAppConfig";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BSpinner,
    BTooltip,
    vSelect
  },
  setup() {
    const { skin } = useAppConfig();
    return { toast: useToast(), skin };
  },
  data() {
    return {
      loading: false,
      tableColumns: [
        { key: "due_date", label: "Data da fatura" },
        { key: "total_expected_amount", label: "Receita prevista" },
        { key: "total_paid_amount", label: "Receita conciliada" },
      ],
      currentPage: 1,
      itemsPerPage: 5,
    };
  },
  computed: {
    ...mapGetters({
      commissionHistory: types.COMPANY_COMMISSION_HISTORY
    }),
    items: function () {
      return this.commissionHistory?.data || [];
    },
    totalItems: function () {
      return this.commissionHistory?.total || 0;
    },
    pageItemsFrom: function () {
      return this.commissionHistory?.from || 0;
    },
    pageItemsTo: function () {
      return this.commissionHistory?.to || 0;
    },
  },
  mounted() {
    this.search();
  },
  methods: {
    ...mapActions({
      getCommissionCompanyHistory: types.GET_COMPANY_COMMISSION_HISTORY,
    }),
    search(currentPage) {
      this.loading = true;
      this.getCommissionCompanyHistory({
        limit: this.itemsPerPage,
        currentPage: Number.isInteger(currentPage)
          ? currentPage
          : this.currentPage,
      })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao buscar os produtos. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.glass-effect {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.28);
  border-radius: 5px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.mouse-pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
